module.exports = __webpack_public_path__ + "img/D202306_3.a6db60f1.jpg";